// XXX: Using "import/export" statements would turn this into (make this) a module.
//      However, the rest of the code is also non-modular and sources would
//      also have to turn into modules. Perhaps it could be done gradually
//      (in itjakub.plugins.dropdownselect2.ts which consumes FavoriteBook)
//      but for now let's not unleash any such "dragons".

// XXX: triple-slash path references don't make TypeScript recognize anything but
//      at least they are clickable in an IDE...

// XXX: triple-slash types references would require "definition files" (.d.ts)...
//      I don't need typing that much now in early development

//// <reference path="../../../node_modules/react/cjs/react.development.js" />
//// <reference path="../../../node_modules/react-dom/cjs/react-dom.development.js" />
/// <reference path="./provisionalLocalization.ts" />
/// <reference path="./FavoriteSelection.tsx" />
//// <reference types="FavoriteSelection" />

// import React from "react";
// import ReactDOM from "react-dom";
declare var React: any, ReactDOM: any

// XXX: Fluent modules' contents are stored on the global (window) but under
//      their own "namespace" object, not directly (unlike other libraries)
// import { FluentBundle, FluentResource } from '@fluent/bundle';
// import { LocalizationProvider, ReactLocalization } from '@fluent/react';
let ReactLocalization = window["FluentReact"].ReactLocalization;

declare const RESOURCES: any;

// import { FavoriteSelection } from "./FavoriteSelection";
declare var FavoriteSelection: any

/*export*/ class FavoriteBook {
    private dropdownSelect: DropDownSelect2;
    private bookType: BookTypeEnum;
    private container: HTMLDivElement;
    private $container: JQuery;
    private bodyDiv: HTMLDivElement;
    private favoriteManager: FavoriteManager;
    private loading: boolean;
    private bookIdList: number[];
    private categoryIdList: number[];

    private localizationScope = "FavoriteJs";
    // private getStringOrFallback: CallableFunction; // or just Function?
    private getStringIdOrFallback: CallableFunction;

    // XXX: name/alias both types that follow
    private stringIdsPerArea: {
        [area in BookTypeEnum]?:
        {
            [stringId: string]: string
        }
    };

    private stringIds: {
        [stringId: string]: string
    };

    constructor(container: HTMLDivElement, bookType: BookTypeEnum, dropdownSelect: DropDownSelect2) {
        this.dropdownSelect = dropdownSelect;
        this.bookType = bookType;
        this.container = container;
        this.$container = $(container);
        this.favoriteManager = new FavoriteManager();
        this.loading = false;
        this.bookIdList = [];
        this.categoryIdList = [];

        this.stringIdsPerArea = {
            [BookTypeEnum.Dictionary]: {
                'ChooseFav': 'SelectFavoriteDictionariesAndGroups', // not "Choose", not "Configure"
            },
            [BookTypeEnum.Edition]: {
                'ChooseFav': 'SelectFavoriteEditionsAndGroups',
            },
        };

        this.stringIds = this.stringIdsPerArea[this.bookType];
        // this.getStringOrFallback = getStringOrFallbackExtension.bind(this); // .../js/itjakub.ts
        this.getStringIdOrFallback = getStringIdOrFallbackExtension.bind(this);
    }

    // A generator function responsible for building the sequence
    // of FluentBundle instances in the order of user's language
    // preferences.
    private _getBundles() {
        let FluentBundle = window["FluentBundle"].FluentBundle;

        const currentLocales = ['cs', 'en']; // DONE: cs (now without the '-CZ'), en-GB/US makes more sense
        let bundles = [];

        for (const locale of currentLocales) {
            const bundle = new FluentBundle(locale);
            bundle.addResource(RESOURCES[locale]);
            bundles.push(bundle);
        }

        return bundles;
    }

    public getFluentLocalization()
    {
        // The ReactLocalization instance stores and caches the sequence of generated
        // bundles. You can store it in your app's state.
        let l10n = new ReactLocalization(this._getBundles());

        return l10n;
    }

    public make()
    {
        const l10n = this.getFluentLocalization();

        // XXX: one could have used a separate, per-area (per-VW "module") scope instead of "FavoriteJs"
        // let buttonText = this.getStringOrFallback("ChooseFav"); // DONE: make this "area/module"-specific

        let buttonTextId = this.getStringIdOrFallback("ChooseFav"); // SelectFavoriteDictionariesAndGroups => select-favorite-dictionaries-and-groups

        //  OLD: document.getElementById("root")
        const root = ReactDOM.createRoot(this.container);

        root.render(
            // <FavoriteSelection buttonText={ buttonText } />,
            React.createElement(FavoriteSelection, { l10n, buttonTextId }, null)
        );

        // XXX: move visibility into the component's state (FavoriteSelection)
        // XXX: later, (gradually) merge this whole file with FavoriteSelection
        this.bodyDiv = this.container.querySelector("div.favorite-book-select-body");
        let headerButton = this.container.querySelector("button.favorite-book-select-button");
        $(headerButton).on("click", this.toggleBodyVisibility.bind(this));

        $(document.documentElement).unbind("click.favoriteBooks");
        $(document.documentElement).bind("click.favoriteBooks", (event) => {
            var parents = $(event.target as Node as Element).parents();
            if (!parents.is(this.$container)) {
                this.hide();
            }
        });
    }

    private toggleBodyVisibility() {
        var bodyJQuery = $(this.bodyDiv);
        if (bodyJQuery.is(":hidden")) {
            this.show();
        } else {
            this.hide();
        }
    }

    public show() {
        this.loadData();

        $(this.bodyDiv).slideDown("fast");
    }

    public hide() {
        $(this.bodyDiv).slideUp("fast");
    }

    public loadData() {
        if (this.loading) {
            return;
        }

        this.loading = true;
        $(this.bodyDiv)
            .empty()
            .append($('<div class="lv-circles sm" style="left: 41.1%; pointer-events: none"></div>'));

        this.favoriteManager.getFavoriteLabelsForBooksAndCategories(this.bookType, (favoriteLabels) => {
            $(this.bodyDiv)
                .empty();

            for (var i = 0; i < favoriteLabels.length; i++) {
                var favoriteLabel = favoriteLabels[i];
                var itemDiv = this.createFavoriteLabel(favoriteLabel);
                this.bodyDiv.appendChild(itemDiv);
            }

            if (favoriteLabels.length === 0) {
                var emptyDiv = document.createElement("div");
                $(emptyDiv)
                    .addClass("text-center")
                    .text(localization.translate("NoTagsHasFav", this.localizationScope).value);
                this.bodyDiv.appendChild(emptyDiv);
            }

            this.loading = false;
        });
    }

    private createFavoriteLabel(favoriteLabel: IFavoriteLabelsWithBooksAndCategories): HTMLDivElement {
        var mainDiv = document.createElement("div");
        var link = document.createElement("a");
        var innerDiv = document.createElement("div");
        var labelSpan = document.createElement("span");

        var color = new HexColor(favoriteLabel.color);
        var fontColor = FavoriteHelper.getDefaultFontColor(color);
        var borderColor = FavoriteHelper.getDefaultBorderColor(color);

        $(labelSpan)
            .addClass("label")
            .addClass("favorite-dropdown-item-label")
            .text(favoriteLabel.name)
            .css("background-color", favoriteLabel.color)
            .css("border-color", borderColor)
            .css("color", fontColor);

        $(innerDiv)
            .addClass("text-center")
            .append(labelSpan);

        $(link)
            .attr("href", "#")
            .data("id", favoriteLabel.id)
            .data("bookIdList", favoriteLabel.projectIdList)
            .data("categoryIdList", favoriteLabel.categoryIdList)
            .click(this.onLabelClick.bind(this))
            .append(innerDiv);

        $(mainDiv)
            .append(link);

        return mainDiv;
    }

    private onLabelClick(event: JQueryEventObject) {
        var linkJquery = $(event.currentTarget);
        this.bookIdList = <number[]>linkJquery.data("bookIdList");
        this.categoryIdList = <number[]>linkJquery.data("categoryIdList");

        if (!this.dropdownSelect.hasBooksLoaded()) {
            this.dropdownSelect.overrideSelectedBookCount(this.bookIdList.length);
        }

        this.dropdownSelect.setSelected(this.categoryIdList, this.bookIdList);
        setTimeout(() => this.dropdownSelect.showBody(), 0);
    }

    public resetSelected() {
        this.bookIdList = [];
        this.categoryIdList = [];

        if (!this.dropdownSelect.hasBooksLoaded()) {
            this.dropdownSelect.overrideSelectedBookCount(null);
        }

        this.dropdownSelect.setSelected(this.categoryIdList, this.bookIdList);
    }

    public getLastSelectedBookIds(): number[] {
        return this.bookIdList;
    }

    public getLastSelectedCategoryIds(): number[] {
        return this.categoryIdList;
    }
}
